import { apiFetch } from './client.js';

export interface UserSummary {
  readonly id: string;
  readonly quartupUserId: string;
  readonly email: string;
  readonly displayName?: string;
  readonly tenant: string;
  readonly isAdmin: boolean;
  readonly isSuperAdmin: boolean;
}

export interface RoleSummary {
  readonly id: string;
  readonly code: string;
  readonly name: string;
}

export interface UserDetail extends UserSummary {
  readonly locale?: string;
  readonly roles: ReadonlyArray<RoleSummary>;
}

export interface ExchangeResult {
  readonly sessionToken: string;
  readonly refreshToken: string;
  readonly user: UserSummary;
}

export interface RefreshResult {
  readonly sessionToken: string;
  readonly refreshToken: string;
}

export interface CheckResult {
  readonly valid: true;
  readonly user: UserSummary;
}

export const authClient = {
  async exchange(erpToken: string): Promise<ExchangeResult> {
    return apiFetch<ExchangeResult>('/auth/exchange', {
      method: 'POST',
      body: JSON.stringify({ token: erpToken }),
    });
  },

  async refresh(refreshToken: string): Promise<RefreshResult> {
    return apiFetch<RefreshResult>('/auth/refresh', {
      method: 'POST',
      body: JSON.stringify({ refreshToken }),
    });
  },

  async logout(opts?: { revokeAll?: boolean }): Promise<void> {
    return apiFetch<void>('/auth/logout', {
      method: 'POST',
      body: JSON.stringify({ revokeAll: opts?.revokeAll ?? false }),
    });
  },

  async check(): Promise<CheckResult> {
    return apiFetch<CheckResult>('/auth/check');
  },

  async me(): Promise<UserDetail> {
    return apiFetch<UserDetail>('/me');
  },
};
